/**
* Object with mock parameter or undefined. Spread the object to include with other parameters.
* @returns \{ mock: mockIndex } or undefined
* @example
* const [ mockParam ] = useMock();
* const params = { startDate: "2022-02-07T23:03:12.000Z", ...mockParam }
**/
export const useMock = (): [ { mock: number } | undefined ] => {
  const params = new URLSearchParams(window.location.search);
  const mock = params.has('mock');
  const mockValue = params.get('mock');
  const mockIndex = mock ? mockValue ? parseInt(mockValue) : 0 : undefined;
  const mockParams = typeof mockIndex === 'number' ? { mock: mockIndex } : undefined;
  return [ mockParams ];
};
